import React, { useEffect, useState } from "react";
import StudBookFilter from "../components/StudBookFilter";
import { Link, useNavigate } from "react-router-dom";
import SubmitBtn from "../components/SubmitBtn";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchStudBookDatathunk,
  FetchStudBookOwnerthunk,
} from "../Redux/StudBook/StudBookAction";
import {
  emptyPage,
  incrementPage,
  resetSearch,
} from "../Redux/StudBook/StudBookSlice";

import { useTranslate } from "../components/TranslationText";

import Loader from "../components/Loader";
import HorseCard from "../components/HorseCard";
import FilterButton from "../components/FilterButton";
import SectionTitle from "../components/SectionTitle";
import PillBtn from "../components/PillBtn";
import SearchBox from "../components/SearchBox";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import { filterResponsive, noDataCard, rightResponsive, serviceRequestHeadContainer, whiteCard } from "../common/cssclasses";

const BaseURL = process.env.REACT_APP_BASE_URL;

export default function StudBookPage() {
  const [regNo, setRegNo] = useState("");
  const [isHoveredSearch, setIsHoveredSearch] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isFilterSection, setIsFilterSection] = useState(false);

  const [isFilterimg, setIsFilterimg] = useState(true);
  const [filterCriteria, setFilterCriteria] = useState({
    gender: [],
    horseUELN: "",
    origin: null,
    birthDateFrom: null,
    birthDateTo: null,
    ownerId: "",
    regNo: "",
    IsBestSearch: false,
    HorseSearchType: null,
    ShowsFrom: null,
    ShowsTo: null,
    ShowRankIds: [],
    SearchWay: null,
    RankFrom: null,
    RankTo: null,
    MedalsList: null,
  });
  const [selectedSearchType, setSelectedSearchType] = useState("1");
  const [notFoundMsg, setNotFoundMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    marginTop: 23,
    textAlign: "center",
    display: "none",
  });
  const navigate = useNavigate();

  const {
    studBookData,
    studBookLoading,
    stateShowMoreButtonHorse,
    page,
    take,
    totalCount,
    currentLanguage,
    stateNoDataFound,
    isLoading
  } = useSelector((state) => state.studBookSlice);
  const { translate } = useTranslate();

  // console.log(studBookData);
  const dispatch = useDispatch();

  const filterHorses = async () => {
    if (regNo === "") {
      setErrorMsg({
        ...errorMsg,
        display: "block",
      });
    } else {
      setErrorMsg({
        ...errorMsg,
        display: "none",
      });
      dispatch(resetSearch());
    }

    //dispatch(emptyPage());
  };

  useEffect(() => {
    if (
      page === 0
    ) {
      dispatch(emptyPage());
      return; // Exit
    }
    if (selectedSearchType === "1") {
      let params = {
        regNo,
        skip: (page - 1) * take,
        take,
        langauge: currentLanguage,
        gender:
          filterCriteria.gender.length === 0 ? null : filterCriteria.gender,
        horseUELN:
          filterCriteria.horseUELN === "" ? null : filterCriteria.horseUELN,
        origin: filterCriteria.origin === "" ? null : filterCriteria.origin,
        birthDateFrom:
          filterCriteria.birthDateFrom === ""
            ? null
            : filterCriteria.birthDateFrom,
        birthDateTo:
          filterCriteria.birthDateTo === "" ? null : filterCriteria.birthDateTo,
        ownerRegisterNumber:
          filterCriteria.ownerId === "" ? null : filterCriteria.ownerId,
        IsBestSearch: filterCriteria.IsBestSearch,
        HorseSearchType: filterCriteria?.HorseSearchType ?? null,
        ShowsFrom: filterCriteria?.ShowsFrom ?? null,
        ShowsTo: filterCriteria?.ShowsTo ?? null,
        ShowRankIds: filterCriteria?.ShowRankIds ?? null,
        SearchWay: filterCriteria?.SearchWay ?? null,
        RankFrom: filterCriteria?.RankFrom ?? null,
        RankTo: filterCriteria?.RankTo ?? null,
        MedalsList: filterCriteria?.MedalsList ?? null,
      };
      dispatch(FetchStudBookDatathunk(params));
      setNotFoundMsg(true);
      setErrorMsg({
        ...errorMsg,
        display: "none",
      });
    }

    if (selectedSearchType === "2") {
      setNotFoundMsg(true);
      let params = {
        ownerId: regNo,
        skip: (page - 1) * take,
        take,
        langauge: currentLanguage,
        //ownerId: filterCriteria.ownerId === "" ? null : filterCriteria.ownerId,
      };
      dispatch(FetchStudBookOwnerthunk(params));
    }
  }, [page, filterCriteria, currentLanguage]);

  const updateStudBookList = (newFilters) => {
    dispatch(emptyPage());
    //setFilterCriteria(newFilters);
    setFilterCriteria({
      ...newFilters,
      regNo,
    });
  };

  const handleChange = (e) => {
    //dispatch(resetSearch());
    //dispatch(emptypage());
    setRegNo(e.target.value);
  };

  const handleSelectedSearchType = (value) => {
    setSelectedSearchType(value);
    dispatch(resetSearch());

    if (value === "1") {
      setIsFilterimg(true);
    }

    if (value === "2") {
      setIsFilterSection(false);
      setIsFilterimg(false);
    }
  };

  const FilterSectionShow = () => {
    setIsFilterSection(!isFilterSection);
  };

  const handelShowMore = async () => {
    dispatch(incrementPage());
  };

  const langauge = localStorage.getItem("eahsLang") ?? "en";

  return (
    <React.Fragment>

      <div className={serviceRequestHeadContainer} style={{ cursor: 'pointer' }}>
        <div
          className={'col-lg-3 col-md-3 col-sm-6 col-6 pe-0 mb-main text-center'}
          id="second_most_used_services"
          onClick={() => handleSelectedSearchType("1")}
        >
          <span className={`${selectedSearchType == "1" ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.horses", "Horse")}</span>

          <div className="service_bar_underline" style={selectedSearchType == "1" ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>
        <div
          className={'col-lg-3 col-md-3 col-sm-6 col-6 ps-0 mb-main text-center '}
          id="second_registration_services"
          onClick={() => handleSelectedSearchType("2")}
        >
          <span className={`${selectedSearchType == "2" ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.owner", "Owner")}</span>
          <div className="service_bar_underline" style={selectedSearchType == "2" ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>
        <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 text-center ms-auto">
          <SearchBox
            onSubmit={(e) => {
              e.preventDefault();
              filterHorses();
            }}
            isFullWidth
            onChange={handleChange}
            placeholder={translate(
              "web.searchStudBook",
              "Search for StudBook, By Name Or Reg Number"
            )}
            isForm={true}
            isStudBookPage={true}
            value={regNo}
            key={'searchBox'}
            onClick={filterHorses}
            onFilterClick={FilterSectionShow}
            showMoreFilter={isFilterimg}
          />
        </div>
      </div>

      <div className="row rtl">
        {isFilterSection && (
          <div className={filterResponsive}>
            <StudBookFilter
              onSubmit={updateStudBookList}
              setRN={setRegNo}
              regNo={regNo}
            />
          </div>
        )}

        <div
          className={
            isFilterSection
              ? `row ${rightResponsive} px-0 mx-0`
              : selectedSearchType === "2"
                ? "row col-md-12 col-sm-12 px-0 mx-0"
                : "row col-md-12 col-sm-12 px-0 mx-0"
          }
        >

          {isLoading ?
            <div className="mb-5">
              <Loader />
            </div>
            :
            <>


              {!!studBookData &&
                studBookData.length > 0 &&
                selectedSearchType === "1" &&
                studBookData.map((item, i) => (
                  <HorseCard isArabicClass={true} item={item} i={i} isFilterSection={isFilterSection} />
                ))}

              {!!studBookData &&
                studBookData.length > 0 &&
                selectedSearchType === "2" &&
                studBookData.map((item, i) => (
                  OwnerCard(i, item, translate, langauge, navigate)
                ))}

              {stateNoDataFound && (
                <React.Fragment>
                  <div
                    className={
                      noDataCard
                    }
                  >
                    {translate("web.nodataFound", "No data Found!")}
                  </div>
                </React.Fragment>
              )}
              <div className="col-12 row">
                <div
                  className={'mx-auto w-unset'}
                >
                  {!studBookLoading &&
                    !!studBookData &&
                    studBookData.length > 0 ? (
                    <NewActionButton
                      disabled={stateShowMoreButtonHorse}
                      onClick={handelShowMore}
                      text={`
                    ${translate("web.showMore", "Show More")} (${studBookData.length
                        } ${translate("web.of", "of")} ${totalCount})`}
                    />
                  ) : (
                    ""
                  )}
                  {studBookLoading &&
                    <div className="mb-5">
                      <Loader />
                    </div>
                  }
                </div>
              </div>
            </>}
        </div>


      </div>
    </React.Fragment>
  );
}
function OwnerCard(i, item, translate, langauge, navigate) {
  return <div key={i} className="col-lg-3 col-md-6 col-sm-12  mb-main rtl">
    <div className="hourseCardClass p-main p-3 h-100 d-flex flex-column">
      <div className="horseCardTitle mb-1" >
        {item.name}
      </div>
      <div className="horseCardDescription">
        {translate("web.regno", "Reg No")}: {item.ownerId}
      </div>
      <div className='col-12 mt-auto'>
        <div className='mainSpacer my-2 ' />
      </div>
      <div className="row ">
        <div className="col-md-6 col-sm-6 mb-sm-0 mb-2">
          <div className='horseCardDescription fw-bold'>
            {translate("web.owns", "owns")}{" "}
            {item.numberofHorsesOwned}{" "}
            {translate("web.horses", "Horses")}
          </div>
        </div>
        <div className="col-md-6 col-sm-6">
          <div className='horseCardDescription fw-bold'>
            {translate("web.breds", "Breds")}{" "}
            {item.numberofHorsesBred}</div>
        </div>
      </div>
      <div className='col-12'>
        <div className='mainSpacer mt-2 mb-main ' />
      </div>
      <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 ms-auto" onClick={() => navigate("/ownerdetails", { state: item })}>
        <PillBtn isNoPadding={true} isNoMargin={true} isRed={true} text={translate("web.viewDetails", "View Details")} isNoAction={true} />
      </div>
    </div>
  </div>;
}

